/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AnalyticsIds} from '@ion/core/src/analytics/types';
import {DateFilterMegaMenu} from '@ion/dls/src/components/menus/DateFilterMegaMenu';
import {DateSelectorValues, Filters, LastFilteredDateProps} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

export interface DateFilterParamsType extends FilterParamsType {
  setSelectedDateFilterValue?: (value?: any) => void;
  selectedDateFilterValue?: DateSelectorValues;
  queryDate?: any;
  ignoreQuery?: any;
  lastFilteredDateProps?: LastFilteredDateProps;
  includeLive?: boolean;
  isBackToMenu?: boolean;
  disabled?: boolean;
  isDefaultValueOnMount?: boolean
};

export const DateFilter = ({
  handleSubmit,
  queryDate,
  ignoreQuery,
  selectedDateFilterValue,
  setSelectedDateFilterValue,
  toggleView,
  isBackToMenu,
  disabled,
  lastFilteredDateProps,
  includeLive = false,
  isDefaultValueOnMount = false
}: DateFilterParamsType) => (
  <DateFilterMegaMenu elementId={AnalyticsIds.assetHistoryDateFilter}
    menuRight='0'
    selectFieldMinWidth='0'
    menuWidth='68%'
    name={Filters.date}
    includeLive={includeLive}
    isBackToMenu={isBackToMenu}
    toggleView={toggleView}
    onSubmit={handleSubmit}
    disabled={disabled}
    custom={Boolean(queryDate) && !ignoreQuery}
    selectedFilterValue={selectedDateFilterValue}
    lastFilteredDateProps={lastFilteredDateProps}
    setSelectedFilterValue={setSelectedDateFilterValue}
    isDefaultValueOnMount={isDefaultValueOnMount}
    overrideDateTimePickerStyles={{
      'div.MuiPickersCalendarHeader-monthTitleContainer h6' : {
        fontSize : '22px !important'
      }
    }}
    dateTimePickerPlaceHolder='mm/dd/yyyy hh:mm (am|pm)' />
);
